import { render, staticRenderFns } from "./VxSpanSelect.vue?vue&type=template&id=788b8b89&scoped=true"
import script from "./VxSpanSelect.vue?vue&type=script&lang=js"
export * from "./VxSpanSelect.vue?vue&type=script&lang=js"
import style0 from "./VxSpanSelect.vue?vue&type=style&index=0&id=788b8b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b8b89",
  null
  
)

export default component.exports